import { Animal } from '@tcc-mono/vandijk/shared/data-access/models';

/** Snelle lookup-set: country_code + identification_number (zelfde formaat als RVO-pool). */
export function buildAnimalSelectionKeySet(animals: Animal[] | undefined | null): Set<string> {
  const keys = new Set<string>();
  for (const animal of animals ?? []) {
    if (animal?.country_code != null && animal?.identification_number != null) {
      keys.add(`${animal.country_code}${animal.identification_number}`);
    }
  }
  return keys;
}

export function rvoAnimalKey(animal: { dierLandcode?: string; dierLevensnummer?: string }): string {
  return `${animal.dierLandcode ?? ''}${animal.dierLevensnummer ?? ''}`;
}
